export function init() {
  ICMIB.votes.watchVotes('#ideas, #results');
  watchFollows('#ideas, #results');
  searchHint();
  initStatusTooltips();
  initSearchAutocomplete();
  initAjaxSearch();
}

// ideas/show
export function initSingleIdea() {
  const $idea = $('.idea');
  ICMIB.votes.watchVotes($idea);
  watchFollows($idea);
}

// ideas/search
export function initSearchPage() {
  ICMIB.votes.watchVotes('#results');
  watchFollows('#results');
  searchHint();
  initSearchAutocomplete();
}

function searchHint() {
  $('#search')
    .on('focus', showSearchHint)
    .on('blur', hideSearchHint);
}

function showSearchHint() {
  $('#search_hint').removeClass('disappear');
}
function hideSearchHint() {
  $('#search_hint').addClass('disappear');
}

function initSearchAutocomplete() {
  const $search = $('#search');
  if (!$search.length) {
    return false;
  }

  return require.ensure(
    [],
    function() {
      if (!window.$ || !window.$.fn.typeahead) {
        require('../vendor/typeahead');
      }

      const ideas = new window.Bloodhound({
        datumTokenizer(d) {
          return window.Bloodhound.tokenizers.whitespace(d.name);
        },
        queryTokenizer: window.Bloodhound.tokenizers.whitespace,
        prefetch: {
          url: $search.data('library-url'),
        },
        remote: {
          url: $search.data('url') + '?search=%QUERY',
          wildcard: '%QUERY',
        },
        dupDetector(remoteMatch, localMatch) {
          return remoteMatch.name === localMatch.name;
        },
      });

      ideas.clearPrefetchCache();
      ideas.initialize();

      const finder = $search.typeahead(
        { autoselect: true },
        {
          name: 'names',
          displayKey: 'name',
          source: ideas.ttAdapter(),
        }
      );

      return finder.on('typeahead:selected', () =>
        $search.closest('form').submit()
      );
    },

    'typeahead'
  );
}

function watchFollows(parent) {
  return $(parent).on('click', '.follow', function(e) {
    e.preventDefault();
    $.get(this.href, { dataType: 'script' });
    return false;
  });
}

function initStatusTooltips() {
  return $('.tip-status').tooltip({ delay: { show: 500, hide: 100 } });
}

// Ajax search

function initAjaxSearch() {
  const $search_form = $('#search_form');
  return $search_form.on('submit', function(e) {
    e.preventDefault();
    $.ajax({
      url: this.action,
      type: this.method,
      data: $search_form.serialize(),
      beforeSend() {},
      complete() {},
      success: handleAjaxSearchSuccess,
      error() {},
    });
    return false;
  });
}

function handleAjaxSearchSuccess(data) {
  const $results = $('#results');
  const $ideas = $('#ideas');
  const $reset = $('<a></a>', { href: '#ideas', title: 'Reset' })
    .html('&times;')
    .addClass('close');
  $reset.on('click', handleResetClick);

  hideIdeas($ideas);

  return ICMIB.delay(250, function() {
    showResults($results, data);
    showApplicableResults($results);
    watchVoteOrNew($results);
    $results.find('.nav').append($reset);
    ICMIB.uploader.findOrCreateUploader($results.find('.mlt_upl'));
    initValidations($results.find('form'));
    return ICMIB.common.initTooltips($results.find('form'));
  });
}

function hideIdeas($ideas) {
  $ideas.addClass('disappear-m');
  return ICMIB.delay(200, () => $ideas.hide());
}

function showIdeas($ideas) {
  $ideas.show();
  return ICMIB.delay(10, () => $ideas.removeClass('disappear-m'));
}

function showResults($results, data) {
  if (data != null) {
    $results.html(data);
  }
  $results.show();
  return ICMIB.delay(10, () => $results.removeClass('disappear-m'));
}

function hideResults($results) {
  $results.addClass('disappear-m');
  return ICMIB.delay(200, () => $results.hide());
}

function watchVoteOrNew($results) {
  // careful with this. This will break if the html changes
  return $results.find('.nav').on('click', 'a:not(.login)', toggleVoteOrNew);
}

function toggleVoteOrNew(e) {
  e.preventDefault();
  const $this = $(this);
  const $hide_target = $(
    $this
      .closest('li')
      .addClass('active')
      .siblings()
      .removeClass('active')
      .find('a')
      .data('target')
  );
  $hide_target.hide();
  const $show_target = $($this.data('target'));
  $show_target.show();
  return false;
}

// If there are results, show only those. If no results, show only the form
function showApplicableResults($results) {
  if ($results.find('#search-results-ideas').children().length > 0) {
    return $results.find('#new-form').hide();
  } else {
    $results.find('#search-results').hide();
    return $results.find('.box_idea_tabs li').toggleClass('active');
  }
}

function handleResetClick(e) {
  e.preventDefault();
  hideResults($('#results'));
  ICMIB.delay(200, () => showIdeas($('#ideas')));
  return false;
}

// VALIDATIONS

export function initValidations(form) {
  import('../legacyValidations').then(() => {
    const idea_validator = $(form).yafov();

    idea_validator.on('invalidfound', function(e, error) {
      // Skip validation on file fields
      if (error.field[0].type === 'file') {
        return true;
      }
      return ICMIB.buildErrorMessage(error);
    });

    idea_validator.on('validfound', function(e, error) {
      // Skip validation on file fields
      if (error.field[0].type === 'file') {
        return true;
      }
      return ICMIB.removeErrorMessage(error);
    });

    idea_validator.on('formvalid', function() {
      return this.submit();
    });

    return idea_validator.on('forminvalid', (e, args) =>
      window.scrollTo(0, args.errors[0].field.parent().position().top - 10)
    );
  });
}
